import { Component, ViewChild } from '@angular/core';
import { NavParams, Content } from 'ionic-angular';
import { BrComService } from '../../service/BrComService';
import { AngularFirestore } from '@angular/fire/firestore';
import { Network } from '@ionic-native/network';

var denunciaListaPageInstance: DenunciaListaPage;

interface localizacao {
  latitute: number,
  longitude: number,
  endereco: string
}

interface denuncia {
  idDenunciaServidor: string,
  codEmpresa: number,
  codUsuario: number,
  titulo: string,
  observacao: string,
  fotos: string[],
  primeiraFoto: string,
  local:localizacao,
  data: string,
  timestamp: any
}

enum collecaoFirestore {
  USUARIO = "usuario",
  DENUNCIAS = "denuncias",
  FOTOS = "fotos"
}

@Component({
  selector: 'page-denuncialista',
  templateUrl: 'denuncialista.html'
})

export class DenunciaListaPage {

  @ViewChild(Content) content: Content;  

  private codEmpresa: number;
  private denuncias: denuncia[];
  private mensagemListaDenuncias: string;

  constructor(private brComService: BrComService, private navParams: NavParams, 
    private db: AngularFirestore, private network: Network) {
    denunciaListaPageInstance = this;
    this.codEmpresa = this.navParams.get("codEmpresa");
    this.denuncias = [];
    this.mensagemListaDenuncias = "";
    this.listarDenuncias();
  }

  private listarDenuncias(){
    const idUsuarioServidor = denunciaListaPageInstance.getIdUsuarioServidor();
    const caminhoDenuncias = denunciaListaPageInstance.getCaminhoDenunciasUsuario(idUsuarioServidor);

    denunciaListaPageInstance.db.collection(caminhoDenuncias).ref.orderBy("timestamp","asc").onSnapshot(
      function (querySnapShot) {
        denunciaListaPageInstance.limparDenunciasNaLista();
        if (querySnapShot.empty){
           denunciaListaPageInstance.definirMensagemSemDenuncias();
        }
        querySnapShot.forEach(
        function (doc) {
            const denuncia = denunciaListaPageInstance.montarDenuncia(doc);
            denunciaListaPageInstance.adicionarDenunciaNaLista(denuncia);
          }
        )
      },
      function (error) {
        denunciaListaPageInstance.definirMensagemErroBuscarDenuncias();
      }
    )
  }

  private limparDenunciasNaLista(){
    denunciaListaPageInstance.denuncias = [];
  }

  private adicionarDenunciaNaLista(denuncia: denuncia) {
    denunciaListaPageInstance.denuncias.push(denuncia);
  }

  private montarDenuncia(documentoDenuncia: any):denuncia{
    const idDocumentoDenuncia = documentoDenuncia.id;
    const dadosDocumentoDenuncia = documentoDenuncia.data();
    const fotos = dadosDocumentoDenuncia.fotos;
    const primeiraFoto = denunciaListaPageInstance.montarPrimeiraFotoParaVisualizacao(dadosDocumentoDenuncia.fotos);
    const codEmpresa = denunciaListaPageInstance.getCodEmpresa();
    const codUsuario = denunciaListaPageInstance.getCodUsuario();
    const titulo = dadosDocumentoDenuncia.titulo;
    const observacao = dadosDocumentoDenuncia.observacao;
    const timestamp = dadosDocumentoDenuncia.timestamp;
    const data = denunciaListaPageInstance.getDataDenuncia(dadosDocumentoDenuncia.timestamp);
    const local = dadosDocumentoDenuncia.local;

    const denuncia = denunciaListaPageInstance.criarDenuncia(idDocumentoDenuncia, codEmpresa, codUsuario, titulo, 
      observacao, fotos, primeiraFoto, timestamp, data, local);

    return denuncia;
  }

  private getPrimeiraFotoDenuncia(fotos: string[]): string {
    if (fotos.length > 0) {
      return fotos[0];
    }
    return "";
  }

  private criarDenuncia(idDenunciaServidor:string, codEmpresa: number, codUsuario: number, titulo: string, observacao: string, 
    fotos: string[], primeiraFoto: string, timestamp: any, data: string, local: localizacao):denuncia {

    const denuncia: denuncia = {
      idDenunciaServidor: idDenunciaServidor,
      codEmpresa: codEmpresa,
      codUsuario: codUsuario,
      titulo: titulo,
      observacao: observacao,
      primeiraFoto: primeiraFoto,
      fotos: fotos,
      local: local,
      data: data,
      timestamp: timestamp
    };

    return denuncia
  }

  private definirMensagemSemDenuncias(){
    let mensagem;
    if (denunciaListaPageInstance.isConectadoInternet()) {
      mensagem = "Você não possui nenhuma denúncia";
    } else {
      mensagem = "Não foi possivel se conectar a internet";
    }
    
    denunciaListaPageInstance.setMensagemListaDenuncia(mensagem);
  }

  public definirMensagemErroBuscarDenuncias(){
    const mensagem = "Ocorreu um erro durante a pesquisa, por favor tente mais tarde."
    denunciaListaPageInstance.setMensagemListaDenuncia(mensagem);
  }

  public registrarDenuncia() {
    denunciaListaPageInstance.brComService.iniciaPaginaDenunciaRegistro(denunciaListaPageInstance.codEmpresa);
  }

  public verDetalhesDenuncia(denuncia:denuncia){
    denunciaListaPageInstance.brComService.iniciaPaginaDenunciaDeatalhes(denuncia);
  }

  ionViewWillEnter() {
    denunciaListaPageInstance.content.resize();
  }

  private montarPrimeiraFotoParaVisualizacao(fotos: string[]):string{
    const imagem64 = denunciaListaPageInstance.getPrimeiraFotoDenuncia(fotos);
    return denunciaListaPageInstance.montarFotoParaVisualizacao(imagem64);
  }

  public montarFotoParaVisualizacao(imagem64: string): string {
    const codificadorImagemJPEGBase64 = "data:image/jpeg;base64,";
    const imagemPadrao = "assets/img/default-sem-imagem.png";
    if (imagem64 != "") {
      return codificadorImagemJPEGBase64 + imagem64;
    }

    return imagemPadrao;
  }

  public isTimestampPronto(timestamp:any):boolean {
    if(!timestamp) {
      return false
    }
    return true
  }

  public isConectadoInternet():boolean {
    const tipoSemConexao = "none";
    if (denunciaListaPageInstance.network.type != tipoSemConexao) { 
      return true;
    }
    return false;
  }

  public isNecessarioMostrarMensagem():boolean {
    return !denunciaListaPageInstance.isMensagemListaDenunciaVazia() && denunciaListaPageInstance.isListaDenunciaVazia();
  }

  public isCarregando():boolean {
    return denunciaListaPageInstance.isMensagemListaDenunciaVazia() && denunciaListaPageInstance.isListaDenunciaVazia();
  }

  public isMensagemListaDenunciaVazia():boolean {
    if (denunciaListaPageInstance.mensagemListaDenuncias.length > 0) {
      return false
    }
    return true;
  }

  public isListaDenunciaVazia():boolean {
    if (denunciaListaPageInstance.getDenuncias().length > 0) {
      return false;
    }
    return true
  }

  private getIdUsuarioServidor():string {
    const codEmpresa = denunciaListaPageInstance.getCodEmpresa();
    const codUsuario = denunciaListaPageInstance.getCodUsuario();
    return `usuario.${codEmpresa}.${codUsuario}`;
  }

  private getCodEmpresa():number{
    return denunciaListaPageInstance.codEmpresa;
  }

  private getCaminhoDenunciasUsuario(idUsuarioServidor: string):string {
    return `${collecaoFirestore.USUARIO}/${idUsuarioServidor}/${collecaoFirestore.DENUNCIAS}`;
  }

  private getCodUsuario():number {
    return denunciaListaPageInstance.brComService.obtemCodUsuarioDaEmpresa(denunciaListaPageInstance.getCodEmpresa());
  }

  private getDenuncias():denuncia[] {
    return denunciaListaPageInstance.denuncias;
  }

  public getDataDenuncia(timestamp: any):string{
    //const data = denunciaListaPageInstance.converterDataUTCEmDataLocal(timestamp);
    if(!timestamp) {
      return
    }
    return denunciaListaPageInstance.brComService.converterTimestampParaDataFormatadaString(timestamp);
  }

  public getMensagemListaDenuncia():string {
    return denunciaListaPageInstance.mensagemListaDenuncias;
  }

  private setMensagemListaDenuncia(mensagem: string){
    denunciaListaPageInstance.mensagemListaDenuncias = mensagem;
  }
}


// WEBPACK FOOTER //
// ./src/pages/denuncialista/denuncialista.ts